<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg"> 
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>Profile</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6" class="text-center">
                  <input type="file" name="profile_pic" @change="changeFile($event)" ref="profile_pic" hidden>
                  <v-badge
                    bordered
                    bottom
                    overlap
                    offset-x="20"
                    offset-y="20"                  
                  >
                    <template v-slot:badge>
                      <v-icon small dark @click="openFileExplorer" class="edit-icon">
                        mdi-pencil
                      </v-icon>
                    </template>
                    <v-avatar
                      size="70"
                      v-if="user.profile_url != null"
                      class="cursor-pointer"
                    >
                      <img :src="API_BASE_URL+ '/uploads/super_admins/profile_pics/' +user.profile_url" :alt="user.name" />
                    </v-avatar>
                    <v-avatar
                      v-if="user.profile_url == null"
                      color="secondary"
                      class="white--text cursor-pointer"
                      size="70"
                    >
                      <span class="font-30">{{ user.name ? user.name.charAt(0) : '' }}</span>
                    </v-avatar>
                  </v-badge>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.name"
                    name="name"
                    prepend-icon="mdi-account-outline"
                    label="name"
                    v-validate="'required'"
                    :error="
                      errors.first('name') != null ||
                      serverSideErrors.name != null
                    "
                    :error-messages="
                      errors.first('name') || serverSideErrors.name
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.email"
                    name="email"
                    prepend-icon="mdi-email-outline"
                    label="Email"
                    type="email"
                    disabled
                    @click:append="showPassword = !showPassword"
                    v-validate="'required|email'"
                    :error="
                      errors.first('email') != null ||
                      serverSideErrors.email != null
                    "
                    :error-messages="
                      errors.first('email') || serverSideErrors.email
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="12" md="6" xs="12">
                  <v-text-field
                    v-model="user.mobile_no"
                    name="Mobile No"
                    prepend-icon="mdi-phone-outline"
                    label="Mobile No"
                    v-validate="'numeric'"
                    :error="
                      errors.first('Mobile No') != null ||
                      serverSideErrors.mobile_no != null
                    "
                    :error-messages="
                      errors.first('Mobile No') || serverSideErrors.mobile_no
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn color="secondary" dark class="px-8 ml-2" @click="updateProfile" :loading="loading">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      loading: false,
      user: {
        name: '',
        email: '',
        mobile_no: '',
      },
      serverSideErrors: {},
      profile_pic: {},
    };
  },
  methods:{
    ...mapMutations('alert',['setAlert']),
    updateProfile() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          formData.append('name',this.user.name);
          formData.append('email',this.user.email);
          formData.append('mobileNumber',this.user.mobile_no);
          formData.append('profile_pic',this.profile_pic);

          console.log("profile",this.profile_pic);
          _self.$axios.post('/superadmin/updateProfile',formData,
          {
            headers: {
              'Content-Type':'multipart/form-data'
            }
          })
          .then( response => {
            let data = response.data;

            _self.loading = false;
            _self.serverSideErrors = {};

            if(data.status) {
              this.user = data.user;
              this.profile_pic = {};

              data.user.role = 'superadmin';
              localStorage.setItem('user',JSON.stringify(data.user)); 

              if(data.user.profile_url) {
                _self.$emit('changeProfilePic');
              }

              this.setAlert({
                showAlert : true,
                message : data.message,
                variant : 'green accent-4',
                timeout : 2000
              });
            } else {
              if(!data.errors) {
                this.setAlert({
                  showAlert : true,
                  message : data.message,
                  variant : 'red accent-3',
                  timeout : 2000
                });
              } else {
                for(let i=0 ; i<data.errors.length ; i++) {
                  this.serverSideErrors[data.errors[i].field] = data.errors[i].message;
                }
              }
            }
          })
        }
      });
    },
    openFileExplorer() {
      this.$refs.profile_pic.click();
    },
    changeFile(e) {
      this.profile_pic = e.target.files[0];
    }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
};
</script>

<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon { 
  z-index: 1000;
}
</style>